import * as XLSX from "xlsx";
import initCapitalize from "./initCapitalize";
import { createModifiersFromModifierFlags } from "typescript";
import { getCurrentDateForReportGeneration } from "./date";

const LocationJSONToExcel = async (JSONdata: any, fileName: string) => {
	try {
		/* generate worksheet and workbook */
		// console.log("JSON Data", JSONdata);
		const { user, reportFieldDetails, response } = JSONdata;
		const mergeCells = [];
		const workbook = XLSX.utils.book_new();
		const worksheet = XLSX.utils.json_to_sheet([]); //
		let pointer = 1;
		// let excelHeaders: string[] = [];
		// console.log("response", response);
		for (let i = 0; i < response.length; i++) {
			const employees = response[i].Employees;
			const locInfo = response[i];

			// /* fix headers */ ["Location Number"];
			// console.log("excelHeaders.length", excelHeaders.length);
			// if (excelHeaders.length == 0) {
			// 	excelHeaders = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] as string[];
			// 	console.log("excelHeaders1111", excelHeaders);
			// }

			const locationDetailsHeader = `Group Number: ${locInfo["Group Number"]}, Location Number: ${locInfo["Location Number"]}, Location Name: ${locInfo["Location Name"]},Total Employees: ${locInfo["Total Employees"]}`;

			// const worksheet = XLSX.utils.format_cell(worksheet["A1"], locationDetailsHeader, {
			// 	"!merges": XLSX.utils.decode_range("A1:I1")
			// });

			const employeeHeader = ["Employee Id", "Employee SSN", "First Name", "Last Name"];
			pointer++;
			XLSX.utils.sheet_add_aoa(worksheet, [[locationDetailsHeader]], { origin: -1 });
			//
			// console.log("pointer for location header", `A${pointer}:I${pointer}`);
			////////////////////////////////////////////////////// Merge Objs ///////////////////////////////
			mergeCells.push(XLSX.utils.decode_range(`A${pointer}:K${pointer}`));
			////////////////////////////////////////////////////// Merge Objs ///////////////////////////////
			////////////////////////////////////////////////////// color cell  ///////////////////////////////
			// console.log("color cell", `A${pointer}`);
			// worksheet[`A${pointer}`].s = {
			// 	fill: {
			// 		patternType: "solid", // none / solid
			// 		fgColor: { rgb: "#000000" },
			// 		bgColor: { rgb: "#666666" }
			// 	}
			// };
			////////////////////////////////////////////////////// color cell  ///////////////////////////////
			// for employees
			pointer++;
			XLSX.utils.sheet_add_aoa(worksheet, [employeeHeader], { origin: -1 });
			for (let i = 0; i < employees.length; i++) {
				const employee = employees[i];
				const empData = [employee.member_id, employee.SSN, employee.first_name, employee.last_name];
				XLSX.utils.sheet_add_aoa(worksheet, [empData], { origin: -1 });
				pointer++;
			}
			//
			pointer++;
			XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });

			// if (!cell["!merges"]) cell["!merges"] = [];
			// cell["!merges"].push(XLSX.utils.decode_range("A1:I1"));

			const _excelHeaders: string[] = [];

			// excelHeaders.forEach((header: string) => {
			// 	const _header =
			// 		header === "employee_SSN"
			// 			? "Employee SSN"
			// 			: header === "Employee Ssn"
			// 			? "Employee SSN"
			// 			: header.includes("_")
			// 			? initCapitalize(header.replaceAll("_", " ")).trim()
			// 			: header === "SSN"
			// 			? header.trim()
			// 			: initCapitalize(header).trim();
			// 	_excelHeaders.push(_header as string);
			// });

			// // console.log("_excelHeaders", _excelHeaders);
			// const _worksSheet = XLSX.utils.aoa_to_sheet([_excelHeaders]);
			// workbook.Sheets["sheet"] = _worksSheet;
			// XLSX.utils.sheet_add_aoa(worksheet, [_excelHeaders], { origin: -1 });
			// XLSX.utils.sheet_add_aoa(
			// 	worksheet,
			// 	[
			// 		[
			// 			"Location Number: ",
			// 			response[i]["Location Number"],
			// 			"Location Name",
			// 			response[i]["Location Name"],
			// 			"Total Employees",
			// 			response[i]["Total Employees"]
			// 		]
			// 	],
			// 	{ origin: -1 }
			// );
			// XLSX.utils.sheet_add_aoa(worksheet, [_excelHeaders], { origin: "A1" });
			// worksheet = XLSX.utils.json_to_sheet(employees);
			// XLSX.utils.book_append_sheet(workbook, _worksSheet);
		}
		// write description of report query
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["This Report is Generated by: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Role: ", initCapitalize(user?.role)]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Name: ", user?.name]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Date: ", getCurrentDateForReportGeneration()]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [[""]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Filter used to run this report: "]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Group Number: ", reportFieldDetails?.group_number]], { origin: -1 });
		XLSX.utils.sheet_add_aoa(worksheet, [["Location Number: ", reportFieldDetails?.location_number]], {
			origin: -1
		});
		// console.log("worksheet", worksheet);
		///
		// if (!worksheet["A2"]["!merges"]) worksheet["A2"]["!merges"] = [];
		// console.log("mergeCells", mergeCells);
		worksheet["!merges"] = mergeCells;
		worksheet["A2"].s = {
			// fill: {
			// 	patternType: "solid", // none / solid
			// 	fgColor: { rgb: "#000000" },
			// 	bgColor: { rgb: "#666666" }
			// },
			font: {
				// bold:true,
				size: 16,
				name: "Times New Roman",
				sz: 16,
				// color: { rgb: "white" },
				bold: true,
				italic: false,
				underline: false
			}
		};

		XLSX.utils.book_append_sheet(workbook, worksheet);
		/* create an XLSX file and try to save to filename.xlsx */
		XLSX.writeFile(workbook, `${fileName}.xlsx`);
		// XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true });
	} catch (error: any) {
		throw error;
	}
};

export default LocationJSONToExcel;

/*

ws['A2'].s = {
	  fill: {
		patternType: "none", // none / solid
		fgColor: {rgb: "FF000000"},
		bgColor: {rgb: "FFFFFFFF"}
	    },
	    font: {
		name: 'Times New Roman',
		sz: 16,
		color: {rgb: "#FF000000"},
		bold: true,
		italic: false,
		underline: false
	    },
	    border: {
		top: {style: "thin", color: {auto: 1}},
		right: {style: "thin", color: {auto: 1}},
		bottom: {style: "thin", color: {auto: 1}},
		left: {style: "thin", color: {auto: 1}}
	    }
	};


	*/
